import API from './axiosClient';

export const getOneVehicle = async (vehicleId) => {
  return API.get(`/vehicle/get_user_vehicle/${vehicleId}`);
};
